<template>
  <div id="login_div">
    <v-container>
      <v-slide-y-transition mode="out-in">
        <v-row :align="alignment" :justify="justify">
          <v-col cols="12">
            <p class="text-center">
              <img src="@/assets/logo_infilesign_white.png" alt="Infile Sign">
            </p>
          </v-col>
          <v-col cols="12" md="4">
            <v-card class="elevation-12">
              <!--<v-toolbar color="primary" dark flat>
                <v-toolbar-title>Inicio de sesión</v-toolbar-title>
                <v-spacer />
              </v-toolbar>
              -->
              <v-card-text>
                <v-alert v-model="error" border="left" close-text="Close Alert" color="error accent-4" dark dismissible>
                  {{texto_error}}
                </v-alert>

                <p>Inicio de sesión</p>
                <v-form ref="form" v-model="valid" lazy-validation>

                  <v-text-field 
                    v-model="username" 
                    label="Correo" 
                    :rules="emailRules" 
                    prepend-icon="email" 
                    id="inputEmail"
                    type="email" />

                  <v-text-field 
                    v-model="password" 
                    label="Contraseña" 
                    prepend-icon="lock" 
                    id="inputPass"
                    :type="show1 ? 'text' : 'password'"
                    :rules="[rules.required, rules.min]" 
                    :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                    @click:append="show1 = !show1"
                  />

                  <span color="success" dark @click.stop="dialog = true" style="cursor: pointer;">
                    Olvide mi contraseña
                  </span>

                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-btn text :to="{name: 'register'}" class="mr-4" color="info">Registro</v-btn>
                <v-spacer />
                <v-btn :disabled="!valid" color="primary"  id="login" class="mr-4" @click="validate" >Iniciar</v-btn>
              </v-card-actions>
            </v-card>


            <v-dialog v-model="dialog" persistent max-width="500px">
              <v-card>
                <v-card-title class="headline">Olvide mi contraseña</v-card-title>
                <v-card-text>

                  <p>Si no recuerdas tu contraseña puedes solicitar el cambio del mismo, ingresa tu correo y te enviaremos los pasos a seguir en tu correo.</p>
                  
                  <v-form @submit.prevent="validateRecover" ref="formRecover" v-model="validRecover" lazy-validation>
                    <v-text-field v-model="email" label="Correo" :rules="emailRules" prepend-icon="email" type="email" />
                  </v-form>

                </v-card-text>
                <v-card-actions>

                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="dialog = false"> Cerrar </v-btn>
                  <v-btn :disabled="!validRecover" type="submit" color="blue darken-1" text @click="validateRecover" >Solicitar</v-btn>

                </v-card-actions>
              </v-card>
            </v-dialog>

          </v-col>
        </v-row>
      </v-slide-y-transition>
    </v-container>
  </div>
</template>
<script>
    import axios from "axios";       
    export default {  
    data: function() {
      return {
          valid: true,
          validRecover: true,
          error: false,
          texto_error: '',
          username: '',
          show1: false,
          password: '',
          email: '',
          justify: 'center',
          alignment: 'center',
          dialog: false,
          emailRules: [
            v => !!v || 'Correo es requerido',
            v => /.+@.+\..+/.test(v) || 'Correo debe ser valido',
          ],
          rules: {
            required: value => !!value || 'Requerido',
            min: v => v.length >= 8 || 'Minimo 8 caracteres',
            emailMatch: () => ('The email and password you entered don\'t match'),
          },
      };
    },
    computed: {
  
    },
    mounted() {
      $("#inputPass, #inputEmail").keyup(function(event) {
        if (event.keyCode === 13) {
          $("#login").click();
        }
      });
    },
    methods: {
      validate () {
          let _this0 = this;
        if (this.$refs.form.validate()) {

          this.$store.dispatch('SET_OVERLAY');
          this.error = false;
          this.texto_error = '';

          this.$store.dispatch('loginRequest', {
            userName: this.username,
            password: this.password
          }).then((response) => {

            setTimeout(function(){
              _this0.$router.push("/");
            },150);

            this.$store.dispatch('MAIN_MENU', response)
            .then(({status}) => {
              this.$store.dispatch('UNSET_OVERLAY');
            })
            .catch(errorMenu => {
              this.$store.dispatch('UNSET_OVERLAY');
              console.log("MAIN_MENU... error");
            })
          }).catch((error) => {   
            this.$store.dispatch('UNSET_OVERLAY');
            if(error.login_failure.length > 0) {
              this.error = true;
              this.texto_error = error.login_failure[0];
              console.log(error);
            }
          });
        }
      },
      validateRecover()
      {
        if (this.$refs.formRecover.validate()) 
        {
          console.log("solicitando nueva link cambio pass");
          this.$store.dispatch('SET_OVERLAY');
          this.dialog = false;
          let paqueteData = { "usuario": this.email }
          let postRecover = axios.post('Password/recuperar_password', paqueteData)
          return postRecover.then((callback) => 
          {
            if(callback.status == 201){
              this.dialog = false;
              this.$store.dispatch('SHOW_ERROR', {show: true, type: 'info', text: 'Solicitud correcta.' });
            } else {
              this.dialog = true;
              this.$store.dispatch('SHOW_ERROR', {show: true, type: 'error', text: 'Hubo un error en el proceso.' });
            }
            this.$store.dispatch('UNSET_OVERLAY');
          }).catch((error) => {
            console.log(error);
            this.dialog = true;
            this.$store.dispatch('UNSET_OVERLAY');
            this.$store.dispatch('SHOW_ERROR', {show: true, type: 'error', text: 'Hubo un error en el proceso.' });
          });
        }
      },
    },
  };
</script>